import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Button: FunctionComponent<Props> = ({
    ariaControls,
    ariaCurrent,
    ariaExpanded,
    ariaLabel,
    ariaPressed,
    ariaSelected,
    children,
    className = '',
    disabled,
    onClick,
    onMouseDown,
    role,
    testId = TEST_ID
}) => (
    <button
        aria-controls={ariaControls}
        aria-current={ariaCurrent}
        aria-expanded={ariaExpanded}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        aria-selected={ariaSelected}
        className={`${styles.button} ${className}`}
        data-testid={testId}
        disabled={disabled}
        onClick={onClick}
        onMouseDown={onMouseDown}
        role={role}
        type="button"
    >
        {children}
    </button>
);

export default Button;
